<template>
    <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      <v-avatar
        class="mr-3"
        color="grey lighten-5"
        size="70"
      >
        <v-img
          contain
          max-height="70%"
          src="https://emoji.slack-edge.com/TCD1KRJS1/ds-whiz-bang/d90d6bf48efc3e84.gif"
        ></v-img>
      </v-avatar>

      <v-toolbar-title class="font-weight-black headline">
        #ds-devops
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <section id="hero">
        <v-row no-gutters>
          <v-img
            :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            :src="require('./assets/badAssssssSong.png')"
          >
          </v-img>
        </v-row>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">ABOUT US</h2>

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
            #ds-devops is a premier devops group focused on data science. We offer extensive services to launch your data-science insights into our exclusive cloud infrastructure, in a continuous, well tested fashion. Have delivered real insights to many industries, we are ready to use our knowledge to provide you with state-of-the-art services and features.
          </v-responsive>

          <v-avatar
            class="elevation-12 mb-12"
            size="128"
          >
            <v-img src="https://emoji.slack-edge.com/TCD1KRJS1/development_operations_as_it_pertains_to_data_science/f72a5549fdaf6e58.jpg"></v-img>
          </v-avatar>

          <div></div>

          <v-btn
            color="grey"
            href="https://ds-devops.biz"
            outlined
            large
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              Our Achievements
            </span>
          </v-btn>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          :src="require('./assets/ArrestedDevops.png')"
        >
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col
                v-for="[value, title] of stats"
                :key="title"
                cols="12"
                md="3"
              >
                <div class="text-center">
                  <div
                    class="display-3 font-weight-black mb-4 orange--text"
                    v-text="value"
                  ></div>

                  <div
                    class="title font-weight-regular text-uppercase blue--text"
                    v-text="title"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>

      <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Blog</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ src, text, title, link }, i) in articles"
              :key="i"
              cols="12"
              md="4"
            >
              <v-img
                :src="src"
                class="mb-4"
                height="275"
                max-width="100%"
              ></v-img>

              <h3
                class="font-weight-black mb-4 text-uppercase"
                v-text="title"
              ></h3>

              <div
                class="title font-weight-light mb-5"
                v-text="text"
              ></div>

              <v-btn
                class="ml-n4 font-weight-black"
                text
                :href="link"
              >
                Continue Reading
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="team">
            <v-container>
                <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Meet the Team</h2>

                <v-responsive
                    class="mx-auto mb-12"
                    width="56"
                >
                    <v-divider class="mb-1"></v-divider>

                    <v-divider></v-divider>
                </v-responsive>
                <v-row>
                    <v-col
                      v-for="({ title, name, img }, i) in people"
                      :key="i"
                      cols="12"
                      md="3"
                    >
                        <v-img :src="img" rounded></v-img>
                        <h3 class="font-weight-black mb-4 text-uppercase">{{ title }}</h3>
                        <div class="title font-weight-light mb-5">{{name}}</div>
                    </v-col>
                </v-row>
            </v-container>

      </section>

      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Contact Us</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-theme-provider light>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  flat
                  label="Name*"
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  flat
                  label="Email*"
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  flat
                  label="Subject*"
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  flat
                  label="Message*"
                  solo
                ></v-textarea>
              </v-col>

              <v-col
                class="mx-auto"
                cols="auto"
              >
                <v-btn
                  color="accent"
                  x-large
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-theme-provider>
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-content>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — #ds-devops
      </div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
      return {
        articles: [
          {
            src: 'https://i.ytimg.com/vi/6Z_XVbECJzw/hqdefault.jpg?sqp=-oaymwEZCNACELwBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLA2SiTQBzp569o_DBY8DR_JThkFsw',
            title: 'What Our Data Scientists Work On -- James Lamb',
            text: 'Data Scientist James Lamb explains the types of projects members of the data science team work on together',
            link: "https://www.youtube.com/watch?v=6Z_XVbECJzw"
          },
          {
            src: 'https://i.ytimg.com/vi/k0Ox_J_Tn5o/hqdefault.jpg?sqp=-oaymwEZCNACELwBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLA98z_TzeBldb1-31JwDr08e_eW0Q',
            title: 'Model Behavior -- Ted Bakanas',
            text: 'This is Ted. Ted is smart.',
            link: 'https://www.youtube.com/watch?v=k0Ox_J_Tn5o'
          },
          {
            src: 'https://blog.jsalv.com/content/images/2020/03/VoronoiDiagram_700.gif',
            title: `Pythonin': Voronoi and K-Means`,
            text: 'James "The Scorpion" Salvatore gives a run-down of Voronoi Diagrams and Python',
            link: "https://blog.jsalv.com/pythonin-voronoi-and-k-means/"
          },
        ],
        stats: [
          ['but one', 'Insight'],
          ['330+', 'Emojis'],
          ['78+', 'Schemas'],
          ['5+', 'Schemes'],
        ],
        people: [
            {
                title: 'Chief Executive Officer',
                name: 'James Salvatore',
                img: 'https://emoji.slack-edge.com/TCD1KRJS1/development_operations_as_it_pertains_to_data_science/f72a5549fdaf6e58.jpg'
            },
            {
                title: 'Chief Financial Officer',
                name: 'James Salvatore',
                img: 'https://emoji.slack-edge.com/TCD1KRJS1/development_operations_as_it_pertains_to_data_science/f72a5549fdaf6e58.jpg'
            },
            {
                title: 'Chief Operating Officer',
                name: 'James Salvatore',
                img: 'https://emoji.slack-edge.com/TCD1KRJS1/development_operations_as_it_pertains_to_data_science/f72a5549fdaf6e58.jpg'
            },
            {
                title: 'Chief Revenue Officer',
                name: 'James Salvatore',
                img: 'https://emoji.slack-edge.com/TCD1KRJS1/development_operations_as_it_pertains_to_data_science/f72a5549fdaf6e58.jpg'
            },
            {
                title: 'Chief Product Officer',
                name: 'James Salvatore',
                img: 'https://emoji.slack-edge.com/TCD1KRJS1/development_operations_as_it_pertains_to_data_science/f72a5549fdaf6e58.jpg'
            },
            {
                title: 'VP of Sales',
                name: 'James Salvatore',
                img: 'https://emoji.slack-edge.com/TCD1KRJS1/development_operations_as_it_pertains_to_data_science/f72a5549fdaf6e58.jpg'
            },
            {
                title: 'Comptroller',
                name: 'Brad Beechler',
                img: 'https://emoji.slack-edge.com/TCD1KRJS1/comptroller-brad/084c32fe2433e01e.png'
            },
            {
                title: 'Assistant Comptroller',
                name: 'Will Dearden',
                img: 'https://emoji.slack-edge.com/TCD1KRJS1/former-assistant-comptroller-willdiesel/d51b917778bd96d9.jpg'
            },
            {
                title: 'Man in Glasses',
                name: 'Bernara Beckerman',
                img: 'https://ca.slack-edge.com/TCD1KRJS1-UCEV1NJ31-aca7c6b11495-192'
                // img: 'https://emoji.slack-edge.com/TCD1KRJS1/bernie_gonna_get_you/b22386333e5ee891.png'
            },
        ]
      }
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
